import React from 'react'
import TabUI from '../../../widgets/output/TabUI'
import TaskLogListSF from './TaskLogListSF'
import MessageListSF from './MessageListSF'
import './TaskDetailBottom.css'

const TaskDetailBottomUI = ({context, messageList, projectUserMap, projectUserList, project, task,
    selectedTab, onCommentClick, onChangeLogClick, setBottomDivRef, scrollToBottom,
    onRefreshComments, onRefreshTaskLogs, refreshComments, refreshTaskLogs, onForceTaskListRefresh

  }) =>
  <div className='c_tsk_dtl_bot'>
    <div className='g_flex_h'>
      <div>
        <TabUI messageList={messageList} labelKey='c_comments' active={selectedTab==='comment'} onClick={onCommentClick} />
        <TabUI messageList={messageList} labelKey='c_change_log' active={selectedTab==='changeLog'} onClick={onChangeLogClick} />
      </div>
      <div className='g_flex_h'>
        <div className='icon icon-refresh g_link_2' onClick={selectedTab === 'comment' ? onRefreshComments : onRefreshTaskLogs} />
        <div className='icon icon-angle-double-down g_link_2' onClick={scrollToBottom} />
      </div>
    </div>

    {
      selectedTab === 'comment' &&
      <MessageListSF
        context={context}
        projectUserMap={projectUserMap}
        projectUserList={projectUserList}
        scrollToBottom={scrollToBottom}
        refreshComments={refreshComments}
        onForceTaskListRefresh={onForceTaskListRefresh}
        project={project}
        task={task}
      />
    }
    {
      selectedTab === 'changeLog' &&
      <TaskLogListSF
        context={context}
        messageList={messageList}
        projectUserMap={projectUserMap}
        refreshTaskLogs={refreshTaskLogs}
        onForceTaskListRefresh={onForceTaskListRefresh}
        project={project}
        task={task}
      />
    }

    <div ref={(element) => setBottomDivRef(element)} />
  </div>

export default TaskDetailBottomUI
